import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue-demi';

interface Props {
  to?: string | null;
  download?: string | boolean | null;
  target?: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbLink',
  props: {
    to: null,
    download: { type: [String, Boolean, null] },
    target: null
  },
  setup(__props: any) {

const props = __props as {
  to?: string | null;
  download?: string | boolean | null;
  target?: string | null;
};



const isExternalLink = computed(() =>
  /^(https?|tel|mailto):/.test(props.to ?? ''),
);

const linkTarget = computed(() =>
  (props.target ?? isExternalLink.value) ? '_blank' : '_self',
);

return { __sfc: true,props, isExternalLink, linkTarget }
}

})